/**
 * @hidden
 */
export var packageMetadata = {
    name: '@progress/kendo-react-form',
    productName: 'KendoReact',
    productCodes: ['KENDOUIREACT', 'KENDOUICOMPLETE'],
    publishDate: 1603297413,
    version: '',
    licensingDocsUrl: 'https://www.telerik.com/kendo-react-ui/my-license/'
};
//# sourceMappingURL=package-metadata.js.map